import React from 'react';
import styled from 'styled-components';
// components
import Toolbar from '../toolbar/toolbar';
import PageContent from './pageContent';

const PageLayout = ({ children, className, hideToolbar = false }) => (
  <div className={className}>
    {!hideToolbar && <Toolbar />}
    <PageContent>{children}</PageContent>
  </div>
);

export default styled(PageLayout)`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
`;
